/**
 * A collection of complex prop types used by the service list and other components
 */

import PropTypes from 'prop-types';
import ssPropTypes from '../../../../modules/ssPropTypes';

/** Defines expectations for a `service` prop */
export const ServicePropType = PropTypes.shape({
  /** The ID of the service, if a single service is present */
  id: PropTypes.number,
  /** The IDs of the individual services, if multiple services are present */
  idList: PropTypes.arrayOf(PropTypes.number),
  /** The name of the service */
  name: PropTypes.string,
  /** The total duration of the service, in minutes */
  total_duration_minutes: PropTypes.number,
  /** The cost of the service */
  cost: ssPropTypes.numberLike,
  /** True if the service may cost more depending on options / smart pricing */
  cost_and_up: PropTypes.bool,
  /** A description of the service */
  blurb: PropTypes.string,
  /** isBlurbDefaulted determines whether the blurb has been set to a default value */
  isBlurbDefaulted: PropTypes.bool,
  /** True if the service is bookable online, otherwise false */
  is_online_bookable: PropTypes.bool,
  /** The name of the service group, if any */
  servicegroup_name: PropTypes.string,
});

/** Defines expectations for a `promotion` prop */
export const PromotionPropType = PropTypes.shape({
  /** A description of the promotion */
  description: PropTypes.string,
  /** The name of the promotion, used for unique checks */
  name: PropTypes.string,
  /** A user-friendly summary of the discount amount */
  formattedDiscount: PropTypes.string,
  /** The start time / date of the promotion */
  startTime: ssPropTypes.moment,
  /** The end time / date of the promotion */
  endTime: ssPropTypes.moment,
});

/** Defines expectations for a `group` prop */
export const ServiceGroupPropType = PropTypes.shape({
  /** The name of the service group */
  name: PropTypes.string,
  /** The index in the overall service list at which the first item in the group will be located */
  startingOverallIndex: PropTypes.number,
  /** The overall index of the service group amongst its siblings */
  index: PropTypes.number,
  /** Services that are inside the service group */
  data: PropTypes.arrayOf(ServicePropType),
});

/** Defines expectations for a `serviceGroups` object from Angular */
export const ServiceGroupType = PropTypes.shape({
  /** The name of the service group (aka category) */
  name: PropTypes.string,
  /** Services that are inside the service group */
  services: PropTypes.arrayOf(ServicePropType),
});
